import { useState } from 'react';
import { AnyPlan, DigitalEntry, DigitalRow } from '../types';
import OfflineBudgetSection from './OfflineBudgetSection/OfflineBudgetSection';
import CountrySummarySection from './CountrySummarySection/CountrySummarySection';
import CountryMetadataSection from './CountryMetadataSection/CountryMetadataSection';
import DigitalBudgetSection from './DigitalBudgetSection/DigitalBudgetSection';

type CountryAccordionProps = {
  country: string;
  plans: AnyPlan[];
  formatBudget: (v?: number, currency?: string) => string;
  getCountryTotals: (
    plan: AnyPlan,
    country: string
  ) => { totalBudget: number; techCosts: number; oneReach?: number };
  getCountryData: (plan: AnyPlan, country: string) => any;
  getDigitalRowsForCountry: (plans: AnyPlan[], country: string) => DigitalRow[];
  getDigitalEntry: (
    plan: AnyPlan,
    country: string,
    row: DigitalRow
  ) => DigitalEntry | undefined;
  getPriorityLabel: (entry?: DigitalEntry) => string;
  firstColWidth?: number;
  showOnlyDifferences: boolean;
};

export default function CountryAccordion({
  country,
  plans,
  formatBudget,
  getCountryTotals,
  getCountryData,
  getDigitalRowsForCountry,
  getDigitalEntry,
  getPriorityLabel,
  firstColWidth = 243,
  showOnlyDifferences,
}: CountryAccordionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      <CountrySummarySection
        country={country}
        plans={plans}
        firstColWidth={firstColWidth}
        getCountryTotals={getCountryTotals}
        expanded={expanded}
        onToggle={() => setExpanded((prev) => !prev)}
      />

      {!expanded ? null : (
        <>
          <CountryMetadataSection
            country={country}
            plans={plans}
            firstColWidth={firstColWidth}
            getCountryData={getCountryData}
            formatBudget={formatBudget}
            showOnlyDifferences={showOnlyDifferences}
          />

          <DigitalBudgetSection
            country={country}
            plans={plans}
            formatBudget={formatBudget}
            getDigitalRowsForCountry={getDigitalRowsForCountry}
            getDigitalEntry={getDigitalEntry}
            getPriorityLabel={getPriorityLabel}
            showOnlyDifferences={showOnlyDifferences}
          />

          <OfflineBudgetSection
            country={country}
            plans={plans}
            formatBudget={formatBudget}
            firstColWidth={firstColWidth}
            showOnlyDifferences={showOnlyDifferences}
          />
        </>
      )}
    </>
  );
}
